/**
 * View component for /audit-logs
 *
 * Generic auditLog list view. Defaults to 'all' with:
 * this.props.dispatch(auditLogActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Helmet } from 'react-helmet';

// import actions
import * as auditLogActions from '../auditLogActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

import auditLogUtils from '../../../global/utils/auditLogUtils';

import * as certificateTemplateActions from '../../certificateTemplate/certificateTemplateActions';
import * as courseActions from '../../course/courseActions';
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as sceneActions from '../../scene/sceneActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as studyRoleActions from '../../studyRole/studyRoleActions';
import * as studyUserActions from '../../studyUser/studyUserActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userActions from '../../user/userActions';

// added 1.17
import * as nodeActions from '../../node/nodeActions';
import * as siteActions from '../../site/siteActions';
import * as siteLocationActions from '../../siteLocation/siteLocationActions';
import * as evaluationActions from '../../evaluation/evaluationActions';
import * as questionActions from '../../question/questionActions';
import * as answerActions from '../../answer/answerActions';

// added 1.19
import * as metricActions from '../../metric/metricActions';
import * as metricCategoryActions from '../../metricCategory/metricCategoryActions';

// added 1.29
import * as sentimentQuestionActions from '../../sentimentQuestion/sentimentQuestionActions';

// import resource components
import AuditLogLayout from '../components/AuditLogLayout.js.jsx';
import AuditLogParentObjectListItem from '../components/AuditLogParentObjectListItem.js.jsx';
class AuditLogDashboard extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if(this.props.match.params.targetType) {
      // fetch new list
      let resourceName = auditLogUtils.parseResourceName(this.props.match.params.targetType, "variable");
      let newResourceName = resourceName == 'group' ? 'study' : resourceName == 'groupUser' ? 'studyUser' : resourceName == 'groupRole' ? 'studyRole' : resourceName; 
      this.props.dispatch(eval(newResourceName + "Actions").fetchListIfNeeded("all"))
      // so doing it this way is cool, but might end up being more interesting than useful. 
      // the intention is to not have to write out different pages for EVERY different resource type.
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("update", prevProps, this.props)
    if(this.props.match.params.targetType && prevProps.match.params.targetType !== this.props.match.params.targetType) {
      // fetch new list
      let resourceName = auditLogUtils.parseResourceName(this.props.match.params.targetType, "variable");
      let newResourceName = resourceName == 'group' ? 'study' : resourceName == 'groupUser' ? 'studyUser' : resourceName == 'groupRole' ? 'studyRole' : resourceName; 
      this.props.dispatch(eval(newResourceName + "Actions").fetchListIfNeeded("all"))
    }
  }

  render() {
    const { 
      auditLogStore
      , certificateTemplateStore
      , courseStore
      , sentimentQuestionStore
      , metricStore
      , metricCategoryStore
      , moduleCertificateStore
      , sceneStore
      , sponsorStore
      , studyStore
      , studyRoleStore
      , studyUserStore
      , contentModuleStore
      , userStore
      , nodeStore
      , siteStore
      , siteLocationStore
      , evaluationStore
      , questionStore
      , answerStore
    } = this.props;

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */

    let resourceName = auditLogUtils.parseResourceName(this.props.match.params.targetType, "variable");
    // console.log("RESOURCENAME", resourceName)
    // console.log("trying to load", resourceName, `${resourceName}Store`)
    let newResourceName = resourceName == 'group' ? 'study' : resourceName == 'groupUser' ? 'studyUser' : resourceName == 'groupRole' ? 'studyRole' : resourceName; 
    let objectList = resourceName && eval(`${newResourceName}Store`) ? eval(`${newResourceName}Store`).util.getList("all") : [];
    // console.log("list", objectList)
    const isEmpty = (
      !objectList
      || objectList.length == 0
      )
      
    // console.log("render checks",isEmpty, objectList ? objectList.length : "null")

    return (
      <AuditLogLayout>
        <Helmet
          title={"Audit Log Dashboard | Pro-ficiency"}
        />
        <h1> Audit Log Dashboard</h1>
        { resourceName ?
          <div>
            <hr/>
            <p>Select a {resourceName} from the list to view it's audit logs</p>
            <ul>
              { !isEmpty ? objectList.map((object, i) =>
                <AuditLogParentObjectListItem
                  key={object._id + i}
                  resourceName={resourceName}
                  object={object}
                />
              )
              : <li>loading..</li>
              }
            </ul>
          </div>
          : <p>Select Object Type To View In The Navbar</p>
        }
      </AuditLogLayout>
    )
  }
}

AuditLogDashboard.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    answerStore: store.answer
    , auditLogStore: store.auditLog
    , certificateTemplateStore: store.certificateTemplate
    , courseStore: store.course
    , evaluationStore: store.evaluation
    , sentimentQuestionStore: store.sentimentQuestion
    , metricStore: store.metric
    , metricCategoryStore: store.metricCategory
    , moduleCertificateStore: store.moduleCertificate
    , nodeStore: store.node
    , questionStore: store.question
    , sceneStore: store.scene
    , sponsorStore: store.sponsor
    , studyStore: store.study
    , studyRoleStore: store.studyRole
    , studyUserStore: store.studyUser
    , siteStore: store.site
    , siteLocationStore: store.siteLocation
    , contentModuleStore: store.contentModule
    , userStore: store.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AuditLogDashboard)
);



// WEBPACK FOOTER //
// modules/auditLog/views/AuditLogDashboard.js.jsx